




























































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import webrtcService from '@/service/webrtcService';
import { ChatInfo, ENUM_CONNECT_STATE, StreamInfo } from 'webrtc-zego/sdk/common/zego.entity';
import { State, Mutation } from 'vuex-class';
import { setChatInfo } from '@/store/mutations';
import ClipboardJS from 'clipboard';

@Component({})
export default class Index extends Vue {
    ruleForm = {
        password: '',
    };
    logo = require('../../assets/images/Logo.png');
    bg = require('../../assets/images/bg.png');

    roomId: string = '';
    cp = '即构课堂';
    name = '即构大班直播课堂';
    appId = '';
    userId = '';
    @State('userList')
    userList!: any[];
    //   1 未开始 2直播中 3 已结束
    liveStatus: 0 | 1 | 2 | 3 | 4 = 0;
    inputMsg = '';
    idName = webrtcService.idName;
    messageObj: any = {
        cameraStatus: false,
        userId: '',
    };
    allBan = false;
    allBanText = '全员禁言';
    banUserArr: number[] = [];

    useWB = false;
    useScreen = false;

    setting = true;
    resolutionSetting = false;
    visible2 = true;
    redSelect = true;
    blueSelect = false;
    earSelect = false;
    previewStatus = false;
    @State('chatList')
    chatList!: ChatInfo[];
    @Mutation(setChatInfo)
    setChatInfo!: (p: ChatInfo[]) => void;

    videoOpen = true;
    audioOpen = true;
    clipboard!: ClipboardJS;

    mounted() {
        this.roomId = this.$route.params.roomId;
        this.cp = this.$route.query.cp as string;
        this.name = this.$route.query.name as string;
        this.appId = this.$route.query.appId as string;
        this.userId = this.$route.query.userId as string;
        // console.log(this.roomId)
        // console.log(this.userId)
        const urlSp = new URLSearchParams(new URL(location.href).search);
        const studentUrl = location.origin + location.pathname.replace('push', 'student') + '?' + urlSp.toString();
        this.clipboard = new ClipboardJS('.share', {
            text() {
                return studentUrl;
            },
        });
        this.clipboard.on('success', () => {
            this.$message({ message: '成功复制到粘贴板，快去分享吧', type: 'success' });
        });
        this.clipboard.on('error', () => {
            this.$message.error('复制到粘贴板失败，手动复制一下地址吧:' + studentUrl);
        });

        webrtcService.play = this.play;
        webrtcService.stopPlay = this.stopPlay;
        webrtcService.onStreamExtraInfoUpdated = this.onStreamExtraInfoUpdated;

        this.teachPushStreamId = 'stream-' + this.userId + '-' + this.appId + '-' + new Date().getTime();
        this.teachPushScreenStreamId = 'screen-' + this.userId + '-' + this.appId + '-' + new Date().getTime();
    }

    useLocalStreamList: StreamInfo[] = [];
    teachPushStreamId = 'stream-' + this.userId + '-' + this.appId + '-' + new Date().getTime();
    teachPushScreenStreamId = 'screen-' + this.userId + '-' + this.appId + '-' + new Date().getTime();
    get useLocalStreamListOnlyStudent() {
        return this.useLocalStreamList.filter(s => s.stream_id.startsWith('student'));
    }

    play(stream: StreamInfo) {
        stream.extra_info &&
            typeof stream.extra_info === 'string' &&
            (stream.extra_info = JSON.parse(stream.extra_info));
        // 同时发起导致连麦人数超过，此时由主播决定谁下麦
        if (this.useLocalStreamList.filter(s => s.stream_id.startsWith('student')).length === 3) {
            this.closeStudentPush(stream.anchor_id_name);
            return;
        }
        this.useLocalStreamList.push(stream);
        // 开始拉流
        this.$nextTick(() => {
            // 拉学生流
            webrtcService.pull((this.$refs[stream.stream_id] as HTMLVideoElement[])[0], stream.stream_id);

            if (this.useLocalStreamList.length === 1) {
                webrtcService.reLive(
                    this.$refs.pushVideo2 as HTMLVideoElement,
                    {
                        WBJson: '',
                        withWB: this.useWB ? 1 : 0,
                        withScreen: this.useScreen ? 1 : 0,
                        ...this.messageObj,
                    },
                    this.teachPushStreamId,
                    !this.videoOpen,
                );
            }
        });
    }

    stopPlay(stream: StreamInfo, isLastOne: boolean) {
        const k = this.useLocalStreamList.findIndex(s => s.stream_id === stream.stream_id);
        this.useLocalStreamList.splice(k, 1);

        if (this.useLocalStreamList.length === 0 && !this.useScreen && !this.useWB) {
            webrtcService.reLive(
                this.$refs.pushVideo as HTMLVideoElement,
                { WBJson: '', withWB: this.useWB ? 1 : 0, withScreen: this.useScreen ? 1 : 0, ...this.messageObj },
                this.teachPushStreamId,
                !this.videoOpen,
            );
        }
    }

    startLiveClicked = false;
    startLive() {
        // 防止快速重复点击
        if (this.startLiveClicked) {
            return false;
        }
        this.startLiveClicked = true;
        this.stopLive();
        // 新需求 登录时 加上userId 和 appId
        let appId = Number(this.appId);
        webrtcService.login(this.roomId, 1, appId, this.userId, true).then(
            (list: StreamInfo[]) => {
                let targetVideo: HTMLVideoElement;
                if (this.useWB || this.useScreen) {
                    targetVideo = this.$refs.pushVideo2 as HTMLVideoElement;
                } else {
                    targetVideo = this.$refs.pushVideo as HTMLVideoElement;
                }

                webrtcService.live(
                    targetVideo,
                    this.teachPushStreamId,
                    {
                        WBJson: '',
                        withWB: this.useWB ? 1 : 0,
                        withScreen: this.useScreen ? 1 : 0,
                    },
                    undefined,
                    () => {
                        this.liveStatus = 2;
                        this.previewStatus = false;
                        this.startLiveClicked = false;
                    },
                );
                if (this.useScreen) {
                    webrtcService.pushScreen(this.teachPushScreenStreamId);
                }
            },
            err => {
                console.error(err);
                this.startLiveClicked = false;
                this.$message({
                    message: '开启直播服务失败了！！网络正常连接下，再刷新页面重试一下吧',
                    type: 'warning',
                });
            },
        );
        // } else {
        //     this.$message({
        //         message: '请先关闭本地摄像头',
        //         type: 'warning',
        //     });
        // }
    }

    preview() {
        this.previewStatus = !this.previewStatus;
        if (this.previewStatus) {
            let targetVideo: HTMLVideoElement;
            if (this.useScreen) {
                // this.stopLive()
                this.useScreen = false;
                webrtcService.stopScreen();
                // console.log(this.$refs.pushVideo as HTMLVideoElement);
                targetVideo = this.$refs.pushVideo as HTMLVideoElement;
                // console.log(targetVideo);
            } else if (this.useWB) {
                this.useWB = false;
                targetVideo = this.$refs.pushVideo as HTMLVideoElement;
            } else {
                targetVideo = this.$refs.pushVideo as HTMLVideoElement;
            }

            webrtcService.preview(targetVideo, this.teachPushStreamId, {
                WBJson: '',
                withWB: 0,
                withScreen: 0,
            });
            if (this.useScreen) {
                webrtcService.pushScreen(this.teachPushScreenStreamId);
            }
        } else {
            this.stopLive();
        }
    }

    // 退出房间，退出白板房间
    stopLive() {
        this.liveStatus = 3;
        if (this.useWB) {
            this.stopWhiteRect();
        }

        if (this.useScreen) {
            this.stopScreen();
        }

        if (this.useLocalStreamListOnlyStudent.length > 0) {
            this.useLocalStreamListOnlyStudent.forEach(stream => {
                this.closeStudentPush(stream.anchor_id_name);
            });
        }
        this.videoOpen = true;
        this.audioOpen = true;
        webrtcService.leaveRoom();
    }

    sendMsg() {
        if (this.inputMsg) {
            webrtcService.sendRoomMsg(this.inputMsg, this.idName);
            this.setChatInfo([
                {
                    id_name: this.idName,
                    nick_name: this.idName,
                    role: 1,
                    msg_id: '0',
                    msg_category: 1,
                    msg_type: 1,
                    msg_content: this.inputMsg,
                    send_time: new Date().getTime(),
                },
            ]);

            this.inputMsg = '';
            this.$nextTick(() => {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                document!.querySelector('.chatBody')!.scrollTop = (document!.querySelector(
                    '.chatBody ul li:last-child',
                )! as any).offsetTop!;
            });
        }
    }

    async startWhiteRect() {
        this.useWB = true;
        // this.previewStatus = false;

        if (this.useScreen) {
            this.useScreen = false;
            webrtcService.stopScreen();
        }

        this.$nextTick(async () => {
            let sudentWbInited = webrtcService.room;
            await webrtcService.startWB(this.$refs.pushDIV as HTMLDivElement);
            if (this.liveStatus === 2) {
                if (!sudentWbInited) {
                    webrtcService.reLive(
                        this.$refs.pushVideo2 as HTMLVideoElement,
                        {
                            WBJson: '',
                            withWB: this.useWB ? 1 : 0,
                            withScreen: this.useScreen ? 1 : 0,
                            ...this.messageObj,
                        },
                        this.teachPushStreamId,
                        !this.videoOpen,
                    );
                } else {
                    webrtcService.updateStreamExtraInfo(
                        this.teachPushStreamId,
                        JSON.stringify({
                            WBJson: '',
                            withWB: this.useWB ? 1 : 0,
                            withScreen: this.useScreen ? 1 : 0,
                            ...this.messageObj,
                        }),
                    );
                }
            }
        });
    }

    async stopWhiteRect() {
        this.useWB = false;
        // webrtcService.stopWB();
        if (this.liveStatus === 2 && this.useLocalStreamListOnlyStudent.length === 0) {
            webrtcService.reLive(
                this.$refs.pushVideo as HTMLVideoElement,
                { WBJson: '', withWB: this.useWB ? 1 : 0, withScreen: 0, ...this.messageObj },
                this.teachPushStreamId,
                !this.videoOpen,
            );
        } else if (this.liveStatus === 2) {
            webrtcService.updateStreamExtraInfo(
                this.teachPushStreamId,
                JSON.stringify({
                    withWB: 0,
                    withScreen: this.useScreen,
                    ...this.messageObj,
                }),
            );
        }
    }

    startScreen() {
        if (this.liveStatus === 2) {
            webrtcService.reLive(
                this.$refs.pushVideo2 as HTMLVideoElement,
                { WBJson: '', withWB: this.useWB ? 1 : 0, withScreen: 1, ...this.messageObj },
                this.teachPushStreamId,
                !this.videoOpen,
            );

            this.$nextTick(() => {
                webrtcService.previewScreen(this.$refs.pushVideoScreen as HTMLVideoElement).then(
                    () => {
                        webrtcService.pushScreen(this.teachPushScreenStreamId);
                        this.dumpOptionsInfo();
                    },
                    err => {
                        console.error('屏幕分享预览失败', err);
                        this.stopScreen();
                    },
                );
            });

            if (this.useWB) {
                this.useWB = false;
            }
        } else {
            if (this.previewStatus && this.useWB == false) {
                // this.preview();
                this.previewStatus = false;
                webrtcService.stopPreview(this.$refs.pushVideo as HTMLVideoElement);
            }
            if (this.useWB) {
                // this.stopLive();
                this.useWB = false;
                this.previewStatus = false;
            }
            this.$nextTick(() => {
                webrtcService.previewScreen(this.$refs.pushVideoScreen as HTMLVideoElement).then(
                    () => {
                        // webrtcService.pushScreen();
                        // webrtcService.dumpOptionsInfo(this.$refs.pushVideo as HTMLVideoElement)// to do 在sdk 为啥不允许
                        this.dumpOptionsInfo();
                    },
                    err => {
                        this.stopScreen();
                    },
                );
            });
        }

        this.useScreen = true;
    }
    dumpOptionsInfo() {
        const videoElem: HTMLVideoElement = this.$refs.pushVideoScreen as HTMLVideoElement;
        // if(videoElem != null) {
        if (videoElem.srcObject) {
            const videoObject: any = videoElem.srcObject;
            const videoTrack: any = videoObject.getVideoTracks()[0];
            videoTrack.onended = (a: any, b: any) => {
                // stopCapture();
                this.stopScreen();
            };
        }
        // }
    }

    stopScreen() {
        this.useScreen = false;
        webrtcService.stopScreen();
        if (this.liveStatus === 2 && this.useLocalStreamListOnlyStudent.length === 0) {
            webrtcService.reLive(
                this.$refs.pushVideo as HTMLVideoElement,
                { WBJson: '', withWB: this.useWB ? 1 : 0, withScreen: this.useScreen ? 1 : 0, ...this.messageObj },
                this.teachPushStreamId,
                !this.videoOpen,
            );
        } else if (this.liveStatus === 2) {
            webrtcService.updateStreamExtraInfo(
                this.teachPushStreamId,
                JSON.stringify({
                    withScreen: 0,
                    withWB: this.useWB,
                    ...this.messageObj,
                }),
            );
        }
    }

    Resolution() {
        this.resolutionSetting = true;
        this.setting = false;
    }

    initSetting() {
        if (this.resolutionSetting == true) {
            this.setting = true;
            this.resolutionSetting = false;
        }
    }
    studentBan() {
        if (!this.previewStatus) {
            // this.allBan = !this.allBan;
            // let userList: any = [];
            // this.userList.filter(item => {
            //     if (item.role == 2) {
            //         userList.push(item.idName);
            //     }
            // });
            // // if (allBan) {
            // this.messageObj.studentBan = this.allBan;
            // if (this.allBan) {
            //     this.$message('已全员禁言');
            //     this.allBanText = '全员解禁';
            // } else {
            //     this.allBanText = '全员禁言';
            // }
            // // }
            // webrtcService.sendCustomCommand(userList, this.messageObj);
            this.allBan = !this.allBan;
            this.messageObj.studentBan = this.allBan;
            if (this.allBan) {
                this.$message('已全员禁言');
                this.allBanText = '全员解禁';
            } else {
                this.allBanText = '全员禁言';
            }
            webrtcService.updateStreamExtraInfo(
                this.teachPushStreamId,
                JSON.stringify({
                    withWB: this.useWB,
                    withScreen: this.useScreen,
                    ...this.messageObj,
                }),
            );
        }
    }

    ban(data: any, index: number) {
        this.messageObj.userId = data.id_name;
        webrtcService.sendCustomCommand([''], this.messageObj);
        // console.log('chatList', this.chatList, this.messageObj);
        if (!this.banUserArr.includes(data.id_name)) this.banUserArr.push(data.id_name);
        else
            this.banUserArr.splice(
                this.banUserArr.findIndex(item => item === data.id_name),
                1,
            );
    }

    toggleVideo() {
        if (this.liveStatus == 2) {
            this.videoOpen = !this.videoOpen;
            webrtcService.toggleVideo(this.videoOpen);
            this.messageObj.cameraStatus = !this.videoOpen;
            webrtcService.updateStreamExtraInfo(
                this.teachPushStreamId,
                JSON.stringify({
                    withWB: this.useWB,
                    withScreen: this.useScreen,
                    ...this.messageObj,
                }),
            );
        } else {
            this.preview();
        }
    }
    toggleAudio() {
        this.audioOpen = !this.audioOpen;
        webrtcService.toggleAudio(this.audioOpen);
    }
    pencli(val: string) {
        let name = webrtcService.room.state.memberState.currentApplianceName;
        if (name == 'eraser') {
            webrtcService.room.setMemberState({
                currentApplianceName: 'pencil',
            });
            name = webrtcService.room.state.memberState.currentApplianceName;
            console.log(!this.earSelect);
        }
        if (name == 'pencil') {
            if (val == 'red') {
                this.$message('已选中红色笔');
                webrtcService.room.setMemberState({
                    strokeColor: [247, 19, 11],
                });
                if (!this.redSelect) {
                    this.redSelect = true;
                    this.blueSelect = false;
                    this.earSelect = false;
                } else {
                }
            } else {
                webrtcService.room.setMemberState({
                    strokeColor: [18, 86, 229],
                });
                this.$message('已选中蓝色笔');
                if (!this.blueSelect) {
                    this.blueSelect = true;
                    this.redSelect = false;
                    this.earSelect = false;
                } else {
                }
            }
        }
        // console.log(333);
    }
    redPencli() {
        webrtcService.room.setMemberState({
            strokeColor: [247, 19, 11],
        });
    }

    eraser() {
        webrtcService.room.setMemberState({
            currentApplianceName: 'eraser',
        });
        this.$message('已选中橡皮擦');
        if (!this.earSelect) {
            this.earSelect = true;
            this.redSelect = false;
            this.blueSelect = false;
        } else {
        }
    }

    // 通知学生下麦
    closeStudentPush(idName: string) {
        webrtcService.endJoinLive(
            idName,
            () => {},
            () => {},
        );
        //对端3秒钟无反应 消息通知大家停止拉该流
        setTimeout(() => {
            let streamId,
                stIndex = 0;
            this.useLocalStreamList.forEach((stream, index) => {
                if (stream.anchor_id_name === idName) {
                    streamId = stream.stream_id;
                    stIndex = index;
                }
            });

            if (streamId) {
                this.useLocalStreamList.splice(stIndex, 1);
                webrtcService.sendReliableMsgToDelete(streamId);
                if (this.useLocalStreamList.length === 0 && !this.useScreen && !this.useWB) {
                    webrtcService.reLive(
                        this.$refs.pushVideo as HTMLVideoElement,
                        {
                            WBJson: '',
                            withWB: this.useWB ? 1 : 0,
                            withScreen: this.useScreen ? 1 : 0,
                            ...this.messageObj,
                        },
                        this.teachPushStreamId,
                        !this.videoOpen,
                    );
                }
            }
        }, 1500);
    }

    // 监听到对应学生推流画面，声音开关
    onStreamExtraInfoUpdated(streamList: StreamInfo[]) {
        this.useLocalStreamList = this.useLocalStreamList.map(stream => {
            streamList.forEach(s => {
                if (stream.stream_id === s.stream_id) {
                    stream.extra_info = JSON.parse(s.extra_info);
                }
            });

            return stream;
        });
    }
    // hover出现下麦按钮
    startHover(streamId: string) {
        this.useLocalStreamList = this.useLocalStreamList.map((stream: any) => {
            stream.showClose = stream.stream_id === streamId;
            return stream;
        });
    }
    // hover出现下麦按钮
    endHover(streamId: string) {
        this.useLocalStreamList = this.useLocalStreamList.map((stream: any) => {
            stream.showClose = false;
            return stream;
        });
    }
}
